import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

const TenantDescription = ({ regionCode, regionName, subscription }) => {
  return (
    <React.Fragment>
      <i
        className={styles.regionFlag}
        style={{
          background: `url("https://cdn.auth0.com/manhattan/versions/1.481.0/assets/${regionCode}.svg") no-repeat`
        }}
      />
      <span className={styles.regionName}>
        {regionName}
      </span>
      {subscription && <span className={styles.subscriptionName}>
        {` - ${subscription.name}`}
      </span>}
    </React.Fragment>
  );
};

TenantDescription.propTypes = {
  regionCode: PropTypes.string.isRequired,
  regionName: PropTypes.string.isRequired,
  subscription: PropTypes.object
};

export default TenantDescription;
